import { jsx as _jsx } from "react/jsx-runtime";
import { ErrorContentFromArray } from './ErrorContentFromArray';
import { ErrorContentFromString } from './ErrorContentFromString';
/**
 * This component takes in a variety of types of error
 * and displays them in a list.
 *
 * This component is surfaced because it may be useful in
 * certain scenarios where you want to control the style
 * of the error list without having to write the contents.
 *
 * Most of the time, you should use the `MessageError` or
 * `ErrorCard` components instead.
 */
export const ErrorContent = ({ error }) => {
    if (!error)
        return null;
    if (typeof error === 'string') {
        return _jsx(ErrorContentFromString, { error: ErrorContentFromString });
    }
    if (Array.isArray(error)) {
        return _jsx(ErrorContentFromArray, { errorList: error });
    }
    if (typeof error === 'object' && error.message) {
        return _jsx(ErrorContentFromString, { error: error.message });
    }
    // Todo: add nested object support here.
    // Todo: add support for react-hook-form's weird format.
    return null;
};
